import React, {useEffect} from 'react';
import {Button, Col, Form, Row, InputGroup, Modal, FormCheck} from "react-bootstrap";
import {useState} from "@hookstate/core";
import {Redirect, useLocation} from "react-router-dom";

import './NewJob.scss';
import {
    getNextJobNumber,
    formatPhoneNumber,
    createNewJob,
    getJob,
    editJob,
    deleteJob,
    // getUserData,
    statusTypes,
    formatUSD,
    getClient
} from "../../Services/ApiService";
import ClientSelectModal from "./Components/ClientSelectModal/ClientSelectModal";
import AdditionalOptionsCell from "./Components/AdditionalOptionsCell";
// import {useAuth0} from "@auth0/auth0-react";

function NewJob() {
    const apiError = useState(false);
    // const { user } = useAuth0();
    // const userData = useState({id: '', name: ''});
    const itemInfoCount = useState(2);
    const storedJobNumber = useState(-1);
    const deleteBoxChecked = useState(false);
    const loading = useState(true);
    const warningText = useState("");

    const newJob = useState({
        isEstimate: false,

        jobNumber: 0,
        jobNumberAppend: null,
        customerPO: '',
        salesman: '',
        dateReceived: getToday(),
        dateDue: getToday(true),

        isNewJob: true,
        isCopyChange: false,
        isSpecChange: false,
        jobReferenced: '',
        isProofRequested: false,

        clientId: '',
        clientName: '',
        billingAddressStreet: '',
        billingAddressStreet2: '',
        billingAddressCity: '',
        billingAddressState: '',
        billingAddressZip: '',
        billingContactName: '',
        billingContactPhone: '',
        billingContactEmail: '',

        quantity: '',
        numPages: '',
        flatSize: '',
        finSize: '',
        numFolds: '',
        itemInfo: '',

        materials: '',
        isDuplex: false,

        inks: '',
        outsideServices: '',
        pressId: 0,
        outsidePrinter: '',

        isScoring: false,
        isDiecut: false,
        isFlat: false,
        isGlue: false,

        isBinding: false,
        bindingStyle: null,
        bindingLoc: null,
        isPadding: false,
        paddingSetsOf: '',
        isPerfed: false,
        perfStyle: null,
        isPunched: false,
        punchingLoc: '',
        punchingStyle: '',
        isNumbered: false,
        numberingLoc: '',
        numberingNumbers: '',
        isRoundCorner: false,
        roundCornerLoc: '',

        additionalSpecs: '',

        isPickup: false,
        shippingAddressStreet: '',
        shippingAddressStreet2: '',
        shippingAddressCity: '',
        shippingAddressState: '',
        shippingAddressZip: '',
        shippingContactName: '',
        shippingContactPhone: '',
        shippingContactEmail: '',

        packingType: '',
        packingUnitsOf: '',
        shipVia: '',
        isPrepaid: false,
        isCollect: false,
        poOutsideService: '',

        isPriceQuoted: false,
        lastPrintingQuantity: '',
        lastPrintingPrice: '',
        isTaxExempt: false,
        amountGross: '',
        amountNet: '',
        salesTax: '',
        postage: '',
        shippingFees: '',
        totalAmount: '',
        fileNumber: '',

        status: 'New',
        invoicedDate: '',
        printedDate: ''
    });

    const nextJobNumber = useState(-1);
    const redirectTo = useState(undefined);
    const jobIdToRepeat = useState(new URLSearchParams(useLocation().search).get('repeat'));
    const jobIdToEdit = useState(new URLSearchParams(useLocation().search).get('edit'));
    const jobType = useState('new');

    const isTaxExempt = useState(false);

    useEffect(() => {
        // if (user !== undefined) {
        //     getUserData(user.sub, data => {
        //         userData.set(data);
        //
        //         newJob.salesman.set(userData.get().name);
        //         loading.set(false);
        //     });
        // }

        if (jobIdToRepeat.get() !== null || jobIdToEdit.get() !== null) {
            let jobId;
            if (jobIdToEdit.get() !== null) {
                jobId = jobIdToEdit.get();
                jobType.set('edit');
            }
            else {
                jobId = jobIdToRepeat.get();
                jobType.set('repeat');
            }

            getJob(jobId, _job => {
                if (_job === false) return apiError.set(true);
                const copiedJob = _job[0];

                storedJobNumber.set(copiedJob.jobNumber);

                newJob.set({
                    id: copiedJob.id,
                    isEstimate: copiedJob.isEstimate,

                    jobNumber: nextJobNumber.get(),
                    jobNumberAppend: null,
                    customerPO: "",
                    salesman: copiedJob.salesman,
                    dateReceived: getToday(),
                    dateDue: getToday(true),

                    isNewJob: jobType.get() === 'edit' ? copiedJob.isNewJob === 1 : false,
                    isCopyChange: copiedJob.isCopyChange,
                    isSpecChange: copiedJob.isSpecChange,
                    jobReferenced: jobType.get() === 'repeat' ? copiedJob.jobNumber :
                        jobType.get() === 'edit' ? copiedJob.jobReferenced : '',
                    isProofRequested: copiedJob.isProofRequested,

                    clientId: copiedJob.clientId,
                    clientName: copiedJob.clientName,
                    billingAddressStreet: copiedJob.billingAddressStreet,
                    billingAddressStreet2: copiedJob.billingAddressStreet2,
                    billingAddressCity: copiedJob.billingAddressCity,
                    billingAddressState: copiedJob.billingAddressState,
                    billingAddressZip: copiedJob.billingAddressZip,
                    billingContactName: copiedJob.billingContactName,
                    billingContactPhone: copiedJob.billingContactPhone,
                    billingContactEmail: copiedJob.billingContactEmail,

                    quantity: copiedJob.quantity,
                    numPages: copiedJob.numPages,
                    flatSize: copiedJob.flatSize,
                    finSize: copiedJob.finSize,
                    numFolds: copiedJob.numFolds,
                    itemInfo: copiedJob.itemInfo,

                    materials: copiedJob.materials,
                    isDuplex: copiedJob.isDuplex,

                    inks: copiedJob.inks,
                    outsideServices: copiedJob.outsideServices,
                    pressId: copiedJob.pressId,
                    outsidePrinter: copiedJob.outsidePrinter,

                    isScoring: copiedJob.isScoring,
                    isDiecut: copiedJob.isDiecut,
                    isFlat: copiedJob.isFlat,
                    isGlue: copiedJob.isGlue,

                    isBinding: copiedJob.isBinding,
                    bindingStyle: copiedJob.bindingStyle,
                    bindingLoc: copiedJob.bindingLoc,
                    isPadding: copiedJob.isPadding,
                    paddingSetsOf: copiedJob.paddingSetsOf,
                    isPerfed: copiedJob.isPerfed,
                    perfStyle: copiedJob.perfStyle,
                    isPunched: copiedJob.isPunched,
                    punchingLoc: copiedJob.punchingLoc,
                    punchingStyle: copiedJob.punchingStyle,
                    isNumbered: copiedJob.isNumbered,
                    numberingLoc: copiedJob.numberingLoc,
                    numberingNumbers: copiedJob.numberingNumbers,
                    isRoundCorner: copiedJob.isRoundCorner,
                    roundCornerLoc: copiedJob.roundCornerLoc,

                    additionalSpecs: copiedJob.additionalSpecs,

                    isPickup: copiedJob.isPickup,
                    shippingAddressStreet: copiedJob.shippingAddressStreet,
                    shippingAddressStreet2: copiedJob.shippingAddressStreet2,
                    shippingAddressCity: copiedJob.shippingAddressCity,
                    shippingAddressState: copiedJob.shippingAddressState,
                    shippingAddressZip: copiedJob.shippingAddressZip,
                    shippingContactName: copiedJob.shippingContactName,
                    shippingContactPhone: copiedJob.shippingContactPhone,
                    shippingContactEmail: copiedJob.shippingContactEmail,

                    packingType: copiedJob.packingType,
                    packingUnitsOf: copiedJob.packingUnitsOf,
                    shipVia: copiedJob.shipVia,
                    isPrepaid: copiedJob.isPrepaid,
                    isCollect: copiedJob.isCollect,
                    poOutsideService: copiedJob.poOutsideService,

                    isPriceQuoted: copiedJob.isPriceQuoted,
                    lastPrintingQuantity: copiedJob.quantity,
                    lastPrintingPrice: copiedJob.amountNet,
                    amountGross: copiedJob.amountGross,
                    amountNet: copiedJob.amountNet,
                    salesTax: copiedJob.salesTax,
                    postage: copiedJob.postage,
                    shippingFees: copiedJob.shippingFees,
                    totalAmount: copiedJob.totalAmount,
                    fileNumber: copiedJob.fileNumber,

                    status: 'New'
                })

                getClient(newJob.get().clientId, _client => {
                    isTaxExempt.set(_client[0].isTaxExempt);
                });

                if (jobType.get() === 'edit') {
                    if (copiedJob.isEstimate) {
                        getNextJobNumber(_nextNumber => {
                            if (_nextNumber === false) return apiError.set(true);

                            nextJobNumber.set(_nextNumber);
                            newJob.jobNumber.set(_nextNumber);
                        });
                    } else {
                        const appendedJobNumber = copiedJob.jobNumber + copiedJob.jobNumberAppend;

                        newJob.jobNumber.set(appendedJobNumber);
                        nextJobNumber.set(appendedJobNumber);
                    }
                }
            });
        }

        if (newJob.jobNumber.get() === 0 && jobType.get() !== 'edit') {
            getNextJobNumber(_nextNumber => {
                if (_nextNumber === false) return apiError.set(true);

                nextJobNumber.set(_nextNumber);
                newJob.jobNumber.set(_nextNumber);
            });
        }

        // setTimeout(() => {
        //     loading.set(false); // in case user isn't retrieved for some reason, still want to display page
        // }, 2000);
        loading.set(false);
        // eslint-disable-next-line
    }, []);

    function getToday(addWeek = false) {
        let date = new Date();
        if (addWeek) date.setDate(date.getDate() + 7);

        return date.toISOString().slice(0, 10);
    }

    function checkItemCount() {
        const minLines = 2;
        const maxLines = 5;

        let quantityLineCount, numPagesLineCount, flatSizeLineCount, finSizeLineCount, numFoldsLineCount, itemInfoLineCount;

        if (newJob.quantity.get() !== null) {quantityLineCount = newJob.quantity.get().split("\n").length}
        if (newJob.numPages.get() !== null) {numPagesLineCount = newJob.numPages.get().split("\n").length}
        if (newJob.flatSize.get() !== null) {flatSizeLineCount = newJob.flatSize.get().split("\n").length}
        if (newJob.finSize.get() !== null) {finSizeLineCount = newJob.finSize.get().split("\n").length}
        if (newJob.numFolds.get() !== null) {numFoldsLineCount = newJob.numFolds.get().split("\n").length}
        if (newJob.itemInfo.get() !== null) {itemInfoLineCount = newJob.itemInfo.get().split("\n").length}

        let mostNewLines = 0;

        mostNewLines = quantityLineCount > mostNewLines ? quantityLineCount : mostNewLines;
        mostNewLines = numPagesLineCount > mostNewLines ? numPagesLineCount : mostNewLines;
        mostNewLines = flatSizeLineCount > mostNewLines ? flatSizeLineCount : mostNewLines;
        mostNewLines = finSizeLineCount > mostNewLines ? finSizeLineCount : mostNewLines;
        mostNewLines = numFoldsLineCount > mostNewLines ? numFoldsLineCount : mostNewLines;
        mostNewLines = itemInfoLineCount > mostNewLines ? itemInfoLineCount : mostNewLines;

        if (mostNewLines < minLines) mostNewLines = minLines;
        if (mostNewLines > maxLines) mostNewLines = maxLines;


        itemInfoCount.set(mostNewLines);
    }


    // <editor-fold desc="Job Number Info Modal">
    const showJobNumberInfoModal = useState(false);
    const handleShowJobNumberInfoModal = () => showJobNumberInfoModal.set(true);
    const handleCloseJobNumberInfoModal = () => showJobNumberInfoModal.set(false);

    function JobNumberInfoModal() {
        // noinspection JSValidateTypes
        return (
            <Modal show={showJobNumberInfoModal.get()}
                   onHide={handleCloseJobNumberInfoModal}
                   size={'md'}
                   id={'jobNumberInfoModal'}>
                <Modal.Body>
                    <p className={'mb-0'}>
                        This is the next number available at the time that this page was opened.
                        If another job is created before this page is submitted,
                        that job will have the number {newJob.get().jobNumber}, and this one will be number {newJob.get().jobNumber + 1}.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseJobNumberInfoModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
    // </editor-fold desc="Job Number Info Modal">

    function handleIsPickupChange(e) {
        newJob.isPickup.set(e.target.checked);

        if (e.target.checked) {
            newJob.shippingAddressStreet.set('');
            newJob.shippingAddressStreet2.set('');
            newJob.shippingAddressCity.set('');
            newJob.shippingAddressState.set('');
            newJob.shippingAddressZip.set('');
        }
    }

    function handleIsEstimateChange(e) {
        newJob.isEstimate.set(e.target.checked);

        if (!e.target.checked) {
            newJob.jobNumber.set(nextJobNumber.get());
        } else {
            newJob.jobNumber.set(-1);
        }
    }

    function handleFormSubmission() {
        if (jobType.get() === 'edit') {
            editJob(newJob.get(), jobIdToEdit.get(), editJobRes => {
                if (editJobRes.success) {
                    redirectTo.set(`/job/${editJobRes.message}/`);
                } else {
                    console.log(editJobRes.message);
                    warningText.set(editJobRes.message);
                }
            });
        }
        else {
            createNewJob(newJob.get(), newJobRes => {
                if (newJobRes.success) {
                    redirectTo.set(`/job/${newJobRes.message}/`);
                } else {
                    console.log(newJobRes.message);
                    warningText.set(newJobRes.message);
                }
            });
        }
    }

    function JobNumberDiv() {
        if (newJob.get().isEstimate) {
            return <Col className={'cell'} id={'jobNumber'} sm={2}>
                <label>Job Number:</label>
                <Button variant={"info"} onClick={handleShowJobNumberInfoModal}>?</Button>
                <h3 className={'jobNumberValue'}>Estimate</h3>
            </Col>
        } else if (newJob.jobNumber.get() === 0) { // 0 means waiting on server for next number
            // noinspection JSCheckFunctionSignatures
            return <Col className={'cell'} id={'jobNumber'} sm={2}>
                <label>Job Number:</label>
                <Button variant={"info"} onClick={handleShowJobNumberInfoModal}>?</Button>
                <Form.Control id={'jobNumberValue'}
                              onChange={e => newJob.jobNumber.set(e.target.value)}
                              value={newJob.get().jobNumber}
                />
            </Col>
        } else { // otherwise we have the next number
            // noinspection JSCheckFunctionSignatures
            return <Col className={'cell'} id={'jobNumber'} sm={2}>
                <label>Job Number:</label>
                <Button variant={"info"} onClick={handleShowJobNumberInfoModal}>?</Button>
                <Form.Control id={'jobNumberValue'}
                              onChange={e => newJob.jobNumber.set(e.target.value)}
                              value={newJob.get().jobNumber}
                />
            </Col>
        }
    }

    function editingNotifText() {
        if (jobType.get() !== 'edit') return;

        return <p id={'JobNumberWarning'}>Note: Once submitted, changes cannot be undone.</p>
    }

    function submitButtonDiv() {
        if (newJob.get().clientId === '') {
            return <div id={"submit"}>
                {editingNotifText()}
                <p id={'JobNumberWarning'}>Unable to submit with no client selected</p>
                <Button className='btn btn-primary disabled'
                        id='submitButton'>
                    {jobType.get() === 'edit' ? 'Submit Changes' : 'Submit'}
                </Button>
                <p className={"alert-danger"}>{warningText.get()}</p>
            </div>
        }
        else if (newJob.get().salesman === '' || newJob.get().salesman === null) {
            return <div id={"submit"}>
                {editingNotifText()}
                <p id={'JobNumberWarning'}>Unable to submit with no Salesman</p>
                <Button className='btn btn-primary disabled'
                        id='submitButton'>
                    {jobType.get() === 'edit' ? 'Submit Changes' : 'Submit'}
                </Button>
                <p className={"alert-danger"}>{warningText.get()}</p>
            </div>
        }
        else {
            return <div id={"submit"}>
                {editingNotifText()}
                <Button className='btn btn-primary'
                        id='submitButton'
                        onClick={handleFormSubmission}>
                    {jobType.get() === 'edit' ? 'Submit Changes' : 'Submit'}
                </Button>
                <p className={"alert-danger"}>{warningText.get()}</p>
            </div>
        }
    }

    function handleDeletion() {
        deleteJob(newJob.get().id, newJob.get().jobNumber, _ => {
            redirectTo.set("/");
        })
    }

    // <editor-fold desc="Deletion Modal">
    const showDeletionModal = useState(false);
    const handleShowDeletionModal = () => showDeletionModal.set(true);
    const handleCloseDeletionModal = () => showDeletionModal.set(false);

    function DeletionModal() {
        // noinspection JSValidateTypes
        return (
            <Modal show={showDeletionModal.get()}
                   onHide={handleCloseDeletionModal}
                   size={'md'}
                   id={'deletionModal'}>
                <Modal.Body>
                    <p className={'mb-0'}>
                        Are you sure you want to delete this?<br/>
                        Like... really sure?<br/>
                        It can't be undone.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={"danger"} onClick={handleDeletion}>I'm sure</Button>
                    <Button onClick={handleCloseDeletionModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
    // </editor-fold desc="Job Number Info Modal">


    if (apiError.get()) {
        return <h4>Unable to reach server.</h4>
    }



    if (loading.get()) {
        return <div id={'loading'}>
            <h3>Loading...</h3>
        </div>
    }

    function getNumber(state) {
        if (state.get() === null || state.get() === "") return 0;

        try {
            if (typeof state.get() === "number") return state.get();

            return Number(state.get().match(/[0-9.]+/)[0]);
        } catch {
            return 0;
        }
    }

    function calculateSalesTax() {
        if (isTaxExempt.get()) return 0;

        try {
            // noinspection JSCheckFunctionSignatures
            newJob.salesTax.set(Math.round(newJob.amountNet.get().match(/[0-9.]+/)[0] * process.env.REACT_APP_TAX_RATE * 100) / 100);
        } catch {
            // noinspection JSCheckFunctionSignatures
            newJob.salesTax.set(0);
        }
    }

    function getTotal() {
        calculateSalesTax();

        try {
            // noinspection JSCheckFunctionSignatures
            newJob.totalAmount.set((
                (getNumber(newJob.amountNet)) +
                (getNumber(newJob.salesTax)) +
                (getNumber(newJob.postage)) +
                (getNumber(newJob.shippingFees))
            ));

        } catch (e) {
            console.log(e);
            // noinspection JSCheckFunctionSignatures
            newJob.totalAmount.set(0);
        }
    }

    function handlePricingChange(e) {
        switch (e.target.id) {
            case "amountNet":
                newJob.amountNet.set(e.target.value);
                calculateSalesTax();
                break;
            case "postage":
                newJob.postage.set(e.target.value);
                break;
            case "shippingFees":
                newJob.shippingFees.set(e.target.value);
                break;
            default:
                break;
        }

        getTotal();
    }

    function handleTaxExemptChange(e) {
        if (e.target.checked) {
            newJob.salesTax.set("");
        } else {
            // noinspection JSCheckFunctionSignatures
            newJob.salesTax.set(newJob.amountGross.get() * process.env.REACT_APP_TAX_RATE);
        }

        isTaxExempt.set(e.target.checked);
        getTotal();
    }

    // noinspection JSValidateTypes,RequiredAttributes
    return (
        <div className={"newJob"}>
            <Form className={'newJobForm'}>
                {jobType.get() === 'edit' && submitButtonDiv()}

                <Row id={'topRow'} className={'noBorder'}>
                    <Col id={'isEstimateDiv'}>
                        <Form.Check id={'isEstimate'}
                                    onChange={handleIsEstimateChange}
                                    checked={newJob.get().isEstimate}
                                    label={'Save as estimate'}
                        />
                    </Col>

                    <Col id={'statusDiv'}>
                        <label htmlFor={'statusSelect'}>Status: </label>
                        <select className={'form-select'} id={'statusSelect'}
                                value={newJob.get().status}
                                onChange={e => newJob.status.set(e.target.value)}
                        >
                            {statusTypes.map(status => {
                                return <option key={status} value={status}>{status}</option>
                            })}
                        </select>
                    </Col>

                    <Col id={'clientNameDiv'} md={8}>
                        <Form.Control id={'clientName'}
                                      onChange={e => newJob.clientName.set(e.target.value)}
                                      value={newJob.get().clientName}
                                      placeholder={'Client Name'}
                                      disabled
                        />
                        <div id={'clientSelect'}>
                            <ClientSelectModal jobValues={newJob} isTaxExempt={isTaxExempt} />
                        </div>
                    </Col>
                </Row>

                <Row id={'baseDetails'}>
                    {JobNumberDiv()}
                    <Col as={Form.Label} className={'cell'}>Customer PO:
                        <Form.Control id={'customerPO'}
                                      onChange={e => newJob.customerPO.set(e.target.value)}
                                      value={newJob.get().customerPO}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'}>Salesman:
                        <Form.Control id={'salesman'}
                                      onChange={e => newJob.salesman.set(e.target.value)}
                                      value={newJob.get().salesman}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'}>Date Received:
                        <Form.Control id={'dateReceived'}
                                      onChange={e => newJob.dateReceived.set(e.target.value)}
                                      value={newJob.get().dateReceived}
                                      type={'date'}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'}>Date Due:
                        <Form.Control id={'dateDue'}
                                      onChange={e => newJob.dateDue.set(e.target.value)}
                                      value={newJob.get().dateDue}
                                      type={'date'}
                        />
                    </Col>
                </Row>

                <Row id={'specs'}>
                    <div className={'col-10 cell'} id={'newJobCheckboxes'}>
                        <Row className={'subRow'}>
                            <Form.Check id={'isNewJob'}
                                        onChange={e => newJob.isNewJob.set(e.target.checked)}
                                        checked={newJob.get().isNewJob}
                                        label={'New (Include Specification'}
                            />
                            <Form.Check id='isCopyChange'
                                        onChange={e => newJob.isCopyChange.set(e.target.checked)}
                                        checked={newJob.get().isCopyChange}
                                        label={'With Copy Change'}
                            />
                            <Form.Check id={'isSpecChange'}
                                        onChange={e => newJob.isSpecChange.set(e.target.checked)}
                                        checked={newJob.get().isSpecChange}
                                        label={'With Spec Change'}
                            />
                        </Row>
                        <label className={'row'}>Repeat of Our Order No.:
                            <input type={'text'} id={'jobReferenced'}
                                   onChange={e => newJob.jobReferenced.set(e.target.value)}
                                   value={newJob.get().jobReferenced}
                                   disabled={newJob.get().isNewJob}
                            />
                        </label>
                    </div>
                    <div className={'col cell'}>
                        <Form.Check id='isProofRequested'
                                    onChange={e => newJob.isProofRequested.set(e.target.checked)}
                                    checked={newJob.get().isProofRequested}
                                    label={'Proof Requested'}
                        />
                    </div>
                </Row>

                <Row id={'billingDetails'} className={'addressBlock'}>
                    <h6 className={"addressHeader"}>Sold To:</h6>
                    <div id={'billingInfo'}>
                        <Col className={'address'}>
                            <Form.Control id={'billingAddressStreet'}
                                          onChange={e => newJob.billingAddressStreet.set(e.target.value)}
                                          value={newJob.get().billingAddressStreet}
                                          placeholder={'Street'}
                            />
                            <Form.Control id={'billingAddressStreet2'}
                                          onChange={e => newJob.billingAddressStreet2.set(e.target.value)}
                                          value={newJob.get().billingAddressStreet2}
                                          placeholder={'Street 2'}
                            />
                            <InputGroup>
                                <Form.Control id={'billingAddressCity'}
                                              onChange={e => newJob.billingAddressCity.set(e.target.value)}
                                              value={newJob.get().billingAddressCity}
                                              placeholder={'City'}
                                />
                                <Form.Control className={"addressState"}
                                              id={'billingAddressState'}
                                              onChange={e => newJob.billingAddressState.set(e.target.value)}
                                              value={newJob.get().billingAddressState}
                                              placeholder={'State'}
                                />
                                <Form.Control className={"addressZip"}
                                              id={'billingAddressZip'}
                                              onChange={e => newJob.billingAddressZip.set(e.target.value)}
                                              value={newJob.get().billingAddressZip}
                                              placeholder={'Zip'}
                                />
                            </InputGroup>
                        </Col>
                        <Col className={'contact'}>
                            <div className={'col cell'}>
                                <Form.Control id={'billingContactName'}
                                              onChange={e => newJob.billingContactName.set(e.target.value)}
                                              value={newJob.get().billingContactName}
                                              placeholder={'Billing Contact Name'} />
                                <Form.Control id={'billingContactPhone'}
                                              onChange={e => newJob.billingContactPhone.set(e.target.value)}
                                              value={formatPhoneNumber(newJob.get().billingContactPhone)}
                                              placeholder={'Billing Contact Phone'} />
                                <Form.Control id={'billingContactEmail'}
                                              onChange={e => newJob.billingContactEmail.set(e.target.value)}
                                              value={newJob.get().billingContactEmail}
                                              placeholder={'Billing Contact Email'} />
                            </div>
                        </Col>
                    </div>
                </Row>

                <Row id={'itemInfo'}>
                    <Col as={Form.Label} className={'cell'} md={1}>Quantity:
                        <Form.Control as={'textarea'}
                                      id={'quantity'}
                                      onChange={e => {newJob.quantity.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().quantity}
                                      rows={itemInfoCount.get()}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'} md={1}>Num Pages:
                        <Form.Control as={'textarea'}
                                      id={'numPages'}
                                      onChange={e => {newJob.numPages.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().numPages}
                                      rows={itemInfoCount.get()}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'} md={1}>Flat Size:
                        <Form.Control as={'textarea'}
                                      id={'flatSize'}
                                      onChange={e => {newJob.flatSize.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().flatSize}
                                      rows={itemInfoCount.get()}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'} md={1}>Finished Size:
                        <Form.Control as={'textarea'}
                                      id={'finSize'}
                                      onChange={e => {newJob.finSize.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().finSize}
                                      rows={itemInfoCount.get()}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'} md={1}>Num Folds:
                        <Form.Control as={'textarea'}
                                      id={'numFolds'}
                                      onChange={e => {newJob.numFolds.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().numFolds}
                                      rows={itemInfoCount.get()}
                        />
                    </Col>
                    <Col as={Form.Label} className={'cell'}>Job Title:
                        <Form.Control as={'textarea'}
                                      id={'itemInfoText'}
                                      onChange={e => {newJob.itemInfo.set(e.target.value)}}
                                      onBlur={_ => checkItemCount()}
                                      value={newJob.get().itemInfo}
                                      rows={itemInfoCount.get()}
                                      placeholder={"Enter up to 5 lines"}
                        />
                    </Col>
                </Row>

                <Row id={"materialsRow"}>
                    <Col as={Form.Label} className={'cell'} md={8}>Materials
                        <Form.Control as={"textarea"}
                                      id={'materials'}
                                      onChange={e => newJob.materials.set(e.target.value)}
                                      value={newJob.get().materials}
                        />
                    </Col>
                    <Col className={'cell'} id={'duplex'}>
                        <p id={'header'}>Prints:</p>
                        <div id={'isDuplexRadio'}>
                            <Form.Label className={'isDuplexRadioDiv'}>
                                <Form.Check type={'radio'}
                                            name={`isDuplex}`}
                                            onChange={() => newJob.isDuplex.set(false)}
                                            checked={!newJob.get().isDuplex} />
                                One Side
                            </Form.Label>
                            <Form.Label className={'isDuplexRadioDiv'}>
                                <Form.Check type={'radio'}
                                            name={`isDuplex}`}
                                            onChange={() => newJob.isDuplex.set(true)}
                                            checked={newJob.get().isDuplex} />
                                Two Sides
                            </Form.Label>
                        </div>
                    </Col>
                </Row>

                <Row id={'inksRow'}>
                    <Col className={'cell alignCenter'} sm={4}>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Inks</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control id={`inks`}
                                          onChange={e => newJob.inks.set(e.target.value)}
                                          value={newJob.get().inks} />
                        </InputGroup>
                    </Col>

                    <Col className={'cell alignCenter'} sm={4}>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Outside Service</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control id={`outsideService`}
                                          onChange={e => newJob.outsideServices.set(e.target.value)}
                                          value={newJob.get().outsideServices} />
                        </InputGroup>
                    </Col>

                    <Col className={'cell'} id={'press'}>
                        <p id={'header'}>Press:</p>
                        <div id={'pressRadiosCell'}>
                            <div id={'radios'}>
                                <label>
                                    <Form.Check name={`pressId`}
                                                id={`offset`}
                                                type={'radio'}
                                                onChange={() => {
                                                    newJob.pressId.set(0);
                                                    newJob.outsidePrinter.set('');
                                                }}
                                                checked={newJob.get().pressId === 0}
                                    />
                                    Offset
                                </label>
                                <label>
                                    <Form.Check name={`pressId`}
                                                id={`signShop`}
                                                type={'radio'}
                                                onChange={() => {
                                                    newJob.pressId.set(1);
                                                    newJob.outsidePrinter.set('');
                                                }}
                                                checked={newJob.get().pressId === 1}
                                    />
                                    Sign Shop
                                </label>
                            </div>
                            <div id={'radios'}>
                                <label>
                                    <Form.Check name={`pressId`}
                                                id={`digital`}
                                                type={'radio'}
                                                onChange={() => {
                                                    newJob.pressId.set(2);
                                                    newJob.outsidePrinter.set('');
                                                }}
                                                checked={newJob.get().pressId === 2}
                                    />
                                    Digital
                                </label>
                                <label>
                                    <Form.Check name={`pressId`}
                                                id={`outsidePrinter`}
                                                type={'radio'}
                                                onChange={() => {newJob.pressId.set(3)}}
                                                checked={newJob.get().pressId === 3}
                                    />
                                    Outside Printer
                                </label>
                            </div>
                        </div>
                        {newJob.get().pressId === 3 &&
                            <Form.Control id={`outsideService`}
                                          onChange={e => newJob.outsidePrinter.set(e.target.value)}
                                          value={newJob.get().outsidePrinter}
                                          placeholder={'Outside Printer Name'} />
                        }
                    </Col>
                </Row>

                <AdditionalOptionsCell job={newJob} />

                <Row id={'additionalSpecsDiv'}>
                    <label>Additional Specifications:
                        <Form.Control as={'textarea'}
                                      id={'additionalSpecs'}
                                      onChange={e => newJob.additionalSpecs.set(e.target.value)}
                                      value={newJob.get().additionalSpecs}
                                      rows={10}
                        />
                    </label>
                </Row>

                <Row className={'addressBlock'} id={'deliveryDetails'}>
                    <h6 id={"addressHeader"}>Deliver To:</h6>
                    <div id={'isPickupCheck'}>
                        <Form.Check id={'isPickup'}
                                    onChange={handleIsPickupChange}
                                    checked={newJob.get().isPickup}
                                    label={'Client picking up'}
                        />
                    </div>
                    <div id={'deliveryInfo'}>
                        <Col className={'address'}>
                            <Form.Control id={'shippingAddressStreet'}
                                          onChange={e => newJob.shippingAddressStreet.set(e.target.value)}
                                          value={newJob.get().shippingAddressStreet}
                                          placeholder={'Street'}
                                          disabled={newJob.get().isPickup}
                            />
                            <Form.Control id={'shippingAddressStreet2'}
                                          onChange={e => newJob.shippingAddressStreet2.set(e.target.value)}
                                          value={newJob.get().shippingAddressStreet2}
                                          placeholder={'Street 2'}
                                          disabled={newJob.get().isPickup}
                            />
                            <InputGroup>
                                <Form.Control id={'shippingAddressCity'}
                                              onChange={e => newJob.shippingAddressCity.set(e.target.value)}
                                              value={newJob.get().shippingAddressCity}
                                              placeholder={'City'}
                                              disabled={newJob.get().isPickup}
                                />
                                <Form.Control className={"addressState"}
                                              id={'shippingAddressState'}
                                              onChange={e => newJob.shippingAddressState.set(e.target.value)}
                                              value={newJob.get().shippingAddressState}
                                              placeholder={'State'}
                                              disabled={newJob.get().isPickup}
                                />
                                <Form.Control className={"addressZip"}
                                              id={'shippingAddressZip'}
                                              onChange={e => newJob.shippingAddressZip.set(e.target.value)}
                                              value={newJob.get().shippingAddressZip}
                                              placeholder={'Zip'}
                                              disabled={newJob.get().isPickup}
                                />
                            </InputGroup>
                        </Col>
                        <Col className={'contact'}>
                            <div className={'col cell'}>
                                <Form.Control id={'shippingAddressName'}
                                              onChange={e => newJob.shippingContactName.set(e.target.value)}
                                              value={newJob.get().shippingContactName}
                                              placeholder={'Shipping Contact Name'} />
                                <Form.Control id={'shippingAddressPhone'}
                                              onChange={e => newJob.shippingContactPhone.set(e.target.value)}
                                              value={formatPhoneNumber(newJob.get().shippingContactPhone)}
                                              placeholder={'Shipping Contact Phone'} />
                                <Form.Control id={'shippingAddressEmail'}
                                              onChange={e => newJob.shippingContactEmail.set(e.target.value)}
                                              value={newJob.get().shippingContactEmail}
                                              placeholder={'Shipping Contact Email'} />
                            </div>
                        </Col>
                    </div>
                </Row>

                <Row id={'shippingDetails'}>
                    <Col className={'cell'} id={'packagingType'} sm={1}>
                        <label>
                            <Form.Check name={`packagingType`}
                                        id={`wrap`}
                                        type={'radio'}
                                        onChange={() => {newJob.packingType.set('Wrap')}}
                                        checked={newJob.get().packingType === 'Wrap'}
                            />
                            Wrap
                        </label>
                        <label>
                            <Form.Check name={`packagingType`}
                                        id={`band`}
                                        type={'radio'}
                                        onChange={() => {newJob.packingType.set('Band')}}
                                        checked={newJob.get().packingType === 'Band'}
                            />
                            Band
                        </label>
                    </Col>
                    <Col sm={2}>
                        <p className={'header'}>Units of:</p>
                        <Form.Control id={'unitsOf'}
                                      onChange={e => newJob.packingUnitsOf.set(e.target.value)}
                                      value={newJob.get().packingUnitsOf}
                        />
                    </Col>
                    <Col className={'cell'} id={'shipping'}>
                        <Col as={Form.Label}>Ship Via:
                            <Form.Control id={'shipVia'}
                                          onChange={e => newJob.shipVia.set(e.target.value)}
                                          value={newJob.get().shipVia}
                            />
                        </Col>
                        <div id={'shippingCheckboxes'}>
                            <Form.Check id={'isPrepaid'}
                                        onChange={e => newJob.isPrepaid.set(e.target.checked)}
                                        checked={newJob.get().isPrepaid}
                                        label={'Prepaid'}
                            />
                            <Form.Check id={'isCollect'}
                                        onChange={e => newJob.isCollect.set(e.target.checked)}
                                        checked={newJob.get().isCollect}
                                        label={'Collect'}
                            />
                        </div>
                    </Col>
                    <Col className={'cell'} id={'outsideServices'}>
                        <Form.Label>P.O. Outside Service:
                            <Form.Control id={'poOutsideService'}
                                          onChange={e => newJob.poOutsideService.set(e.target.value)}
                                          value={newJob.get().poOutsideService}
                            />
                        </Form.Label>
                    </Col>
                    <Col className={'cell'} id={'fileNumber'}>
                        <Form.Label>File Number:
                            <Form.Control id={'fileNumber'}
                                          onChange={e => newJob.fileNumber.set(e.target.value)}
                                          value={newJob.get().fileNumber}
                            />
                        </Form.Label>
                    </Col>
                </Row>

                <Row id={'accounting'}>
                    <Col className={'cell'} id={'previous'}>
                        <Form.Check id={'priceQuoted'}
                                    onChange={e => newJob.isPriceQuoted.set(e.target.checked)}
                                    checked={newJob.get().isPriceQuoted}
                                    label={'Price Quoted?'}
                        />
                        <div id={'lastPrintingDetails'}>
                            <Form.Label>Last Printing Quantity:
                                <Form.Control id={'lastPrintingQuantity'}
                                              onChange={e => newJob.lastPrintingQuantity.set(e.target.value)}
                                              value={newJob.get().lastPrintingQuantity}
                                />
                            </Form.Label>
                            <Form.Label>Last Printing Price:
                                <Form.Control id={'lastPrintingPrice'}
                                              onChange={e => newJob.lastPrintingPrice.set(e.target.value)}
                                              value={newJob.get().lastPrintingPrice}
                                />
                            </Form.Label>
                        </div>
                    </Col>
                    <Col className={'cell'} id={'pricing'}>
                        <div id={'taxExemptDiv'}>
                            <FormCheck id={'taxExempt'}
                                       label={"Tax Exempt"}
                                       checked={isTaxExempt.get()}
                                       onChange={e => handleTaxExemptChange(e)}
                            />
                        </div>
                        <InputGroup>
                            <InputGroup.Append><InputGroup.Text>Amount Net</InputGroup.Text><InputGroup.Text className={"dollarSign"}>$</InputGroup.Text></InputGroup.Append>
                            <Form.Control id={'amountNet'}
                                          onChange={e => handlePricingChange(e)}
                                          value={newJob.get().amountNet}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Append><InputGroup.Text>Sales Tax</InputGroup.Text></InputGroup.Append>
                            <Form.Control id={'salesTax'}
                                          value={formatUSD(newJob.get().salesTax)}
                                          disabled
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Append><InputGroup.Text>Postage</InputGroup.Text><InputGroup.Text className={"dollarSign"}>$</InputGroup.Text></InputGroup.Append>
                            <Form.Control id={'postage'}
                                          onChange={e => handlePricingChange(e)}
                                          value={newJob.get().postage}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Append><InputGroup.Text>Shipping Charges</InputGroup.Text><InputGroup.Text className={"dollarSign"}>$</InputGroup.Text></InputGroup.Append>
                            <Form.Control id={'shippingFees'}
                                          onChange={e => handlePricingChange(e)}
                                          value={newJob.get().shippingFees}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Append><InputGroup.Text>Total Amount</InputGroup.Text></InputGroup.Append>
                            <Form.Control id={'totalAmount'}
                                          // onChange={e => newJob.totalAmount.set(e.target.value)}
                                          value={formatUSD(newJob.get().totalAmount)}
                                          disabled
                            />
                        </InputGroup>
                    </Col>
                </Row>

                <Row id={'buttonsRow'}>
                    <div id={"delete"}>
                        {jobType.get() === "edit" &&
                        <div>
                            <Form.Check id={'activateDelete'}
                                        onChange={e => deleteBoxChecked.set(e.target.checked)}
                                        checked={deleteBoxChecked.get()}
                                        label={'Delete'}
                            />

                            {deleteBoxChecked.get() &&
                                <Button className='btn btn-primary'
                                        variant={'danger'}
                                        id='deleteButton'
                                        onClick={handleShowDeletionModal}>
                                    Confirm Deletion
                                </Button>
                            }
                        </div>
                        }
                    </div>

                    {submitButtonDiv()}
                </Row>
            </Form>

            <JobNumberInfoModal />
            <DeletionModal />
            {redirectTo.get() && <Redirect to={redirectTo.get()} />}
        </div>
    );
}

export default NewJob;
